import { createAction } from '@reduxjs/toolkit';
import { api, handleApiErrors } from 'lib/src/utils/api';
import { AppDispatch } from 'src/redux/store';
import { CalendarChallenge, Challenge } from 'src/types/shared/Challenge';
import { arrayToQueryString } from '../../../utils/generic';

export const fetchChallengesForCalendarRequest = createAction('fetchChallengesForCalendarRequest');
export const fetchChallengesForCalendarSuccess = createAction<CalendarChallenge[]>(
    'fetchChallengesForCalendarSuccess',
);
export const fetchChallengesForCalendarFailure = createAction('fetchChallengesForCalendarFailure');

export const fetchChallengesForCalendar = (
    challengeGroupIDs: number[],
    filterFrom: string,
    filterTo: string,
) => async (dispatch: AppDispatch): Promise<void> => {
    dispatch(fetchChallengesForCalendarRequest());
    try {
        const { data } = await api.get<CalendarChallenge[]>(
            `admin/calendar?${arrayToQueryString(
                challengeGroupIDs,
                'challengeGroupIDs',
            )}&filterFrom=${filterFrom}&filterTo=${filterTo}`,
        );
        dispatch(fetchChallengesForCalendarSuccess(data));
    } catch (e) {
        handleApiErrors(dispatch, fetchChallengesForCalendarFailure, e);
    }
};
